import type { AxiosError } from 'axios'

export type ServiceUnavailableError = AxiosError<{ message?: string }>

export function isUnauthorizedError(error: AxiosError): error is AxiosError {
  return error?.isAxiosError && error.response?.status === 403
}

export function isNetworkError(error: AxiosError): error is AxiosError {
  return error?.isAxiosError && !error.response
}

export function isGatewayTimeoutError(error: AxiosError): error is AxiosError {
  return error?.isAxiosError && error.response?.status === 504
}

export function isServiceUnavailableError(error: AxiosError): error is ServiceUnavailableError {
  return error?.isAxiosError && error.response?.status === 503
}
